import { countries } from '@/constants/countries';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface CountrySelectFieldProps {
  countryCode: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const CountrySelectField = ({
  countryCode,
  onChange,
}: CountrySelectFieldProps) => {
  const { t } = useTranslation();

  return (
    <FormGroup>
      <Label $required>{t('common.nationality')}</Label>
      <Select name="countryCode" value={countryCode} onChange={onChange}>
        <option value="">{t('playerSignUp.selectNationality')}</option>

        {countries.map((country) => (
          <option key={country.code} value={country.code}>
            {country.nameKor} ({country.nameEng})
          </option>
        ))}
      </Select>
    </FormGroup>
  );
};

export default CountrySelectField;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

interface LabelProps {
  $required?: boolean;
}

const Label = styled.label<LabelProps>`
  font-size: 13px;
  font-weight: 600;
  color: #4a4a4a;

  &::after {
    content: ${(props) => (props.$required ? "' *'" : "''")};
    color: #ff4d4f;
  }
`;

const Select = styled.select`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 10px 14px;
  font-size: 14px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background-color: #fff;
  outline: none;
`;
